import progressQuery from './progress-query'; // 进度查询
import quanSZMQuery from './quanSZM-query'; // 权属证明查询
import multiUserQuery from './multiUser-query';
import otherQuery from './other-query'; //他人查询
import electronicLicenseRoute from './electronic-license'; //电子证照
import licenseVerify from './license-verify'; //证书核验
import landQuery from './land-query';
/**
 * 信息查询路由配置
 */
export default {
  path: '/home/info-search',
  name: 'info-search',
  component: () => import('iebdc/views/info-search'),
  meta: {
    label: '信息查询',
    permission: 'IEBDC:SY:XXCX:JDCX'
  },
  children: [progressQuery, quanSZMQuery, otherQuery, electronicLicenseRoute, licenseVerify, multiUserQuery, landQuery]
};
